module.exports = __webpack_public_path__ + "static/media/mobile.a9f6b26c.jpg";